import { render, staticRenderFns } from "./AddPanel.vue?vue&type=template&id=05fa6684&"
import script from "./AddPanel.vue?vue&type=script&lang=ts&"
export * from "./AddPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AddPanel.vue?vue&type=style&index=0&id=05fa6684&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports